import React from 'react';
import { Container } from './styles';

interface IPropsTabFilter {
  children: React.ReactNode;
}

export function TabFilter({ children }: IPropsTabFilter) {
  return <Container>{children}</Container>;
}
